import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ProductParameterSizeState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ProductParameterSizeQuery extends QueryEntity<ProductParameterSizeState> {

  constructor(protected store: Store) {
    super(store);
  }

}
